export const FIELD_WIDTH_MAP = {
  s: 3,
  m: 6,
  l: 12,
};

export const getColumnSize = (breakpoint, configKey, manifest) => {
  const defaultSize = breakpoint === 'md' ? 6 : 3;
  const propSize = manifest.config[0][configKey].width;

  return Math.max(FIELD_WIDTH_MAP[propSize] || 0, defaultSize);
};

export const IOT_HUB_BRIDGE_TYPES = ['bridge-niota'];

export const withoutIotHubBridgeTypes = (bridgeTypes, n1Enabled) => {
  if (n1Enabled) {
    return bridgeTypes;
  }

  return (bridgeTypes || []).filter((bridgeType) => !IOT_HUB_BRIDGE_TYPES.includes(bridgeType.type));
};
